import { render, staticRenderFns } from "./default-groups.vue?vue&type=template&id=486514da&scoped=true&"
import script from "./default-groups.ts?vue&type=script&lang=ts&"
export * from "./default-groups.ts?vue&type=script&lang=ts&"
import style0 from "./default-groups.scss?vue&type=style&index=0&id=486514da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486514da",
  null
  
)

export default component.exports